import React, { useEffect, useState } from "react";
import img3 from '../../../../Assets/add/img3.png';
import axios from "axios";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useLocation, useNavigate } from "react-router-dom";
import { Circle } from "lucide-react";
import { Filter } from "lucide-react";
import { CheckCircle, XCircle, ArrowDownAZ, ArrowDownZA } from "lucide-react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ArrowLeft } from 'lucide-react';


const AllAddedVehicles = () => {
    const [states, setStates] = useState([]);
    const [filteredStates, setFilteredStates] = useState([]);
    const [selectedState, setSelectedState] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [isLoadingStates, setIsLoadingStates] = useState(false);
    const [showOptions, setShowOptions] = useState(false);
    const [showOptionsFor, setShowOptionsFor] = useState(null);

    const [showFilter, setShowFilter] = useState(false);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]); // Data from the API
    const [error, setError] = useState(null);

    const [filteredData, setFilteredData] = useState([]); // State for filtered data
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const location = useLocation();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/getVendorDriverDetails/${userId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                setData(response.data.data); // Save the fetched data
                setFilteredData(response.data.data); // Initialize filtered data
                setIsLoading(false); // Set loading to false
                console.log("Fetched data:", response.data.data); // Log the fetched data
            } catch (err) {
                console.error("Error fetching data:", err);
                setError("Failed to fetch data. Please try again later.");
                setIsLoading(false); // Set loading to false even if there's an error
            }
        };

        fetchData();
    }, []);

    const deleteItem = async (vendorDriverCode) => {
        try {
            // Call the backend API to delete the item
            const response = await axios.delete(
                `${process.env.REACT_APP_BACKEND_URL}/api/deletedVendorDriver/${vendorDriverCode}`
            );

            if (response.status === 200) {
                // Update both `data` and `filteredData` to remove the deleted item
                setData((prevData) => prevData.filter((item) => item.vendorDriverCode !== vendorDriverCode));
                setFilteredData((prevFilteredData) =>
                    prevFilteredData.filter((item) => item.vendorDriverCode !== vendorDriverCode)
                );

                toast.success("Driver deleted successfully!"); // Show success toast
                console.log(`Vendor driver with code ${vendorDriverCode} deleted successfully.`);
            } else {
                console.error(`Failed to delete vendor driver with code ${vendorDriverCode}.`);
                toast.error("Failed to delete the driver.");
            }
        } catch (err) {
            console.error("Error deleting vendor driver:", err);
            toast.error("Failed to delete the vendor driver. Please try again.");
        }
    };

    const handleSearch = (e) => {
        const val = e.target.value.toLowerCase();
        setSearchTerm(val);

        // Filter the data based on the search term
        const filtered = data.filter((item) =>
            item.vehicleNo.toLowerCase().includes(val)
        );

        setFilteredData(filtered); // Update the filtered data

        // Show a toast if no data is found
        if (filtered.length === 0) {
            toast.error("No data found!");
        }
    };

    const toggleFilter = () => {
        setShowFilter((prev) => !prev);
    };

    const handleSelect = () => {
        if (selectedState) {
            alert(`You selected: ${selectedState.name}`);
        }
    };

    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <p>Loading...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <p className="text-red-500">{error}</p>
            </div>
        );
    }

    return (
        <div className="min-h-screen h-screen bg-gradient-to-b from-[#2db6ff] to-[#d97aff] flex flex-col font-satoshi">
            <ToastContainer /> {/* Add ToastContainer */}
            {/* Top section */}

            <div className="p-6 text-white text-center">
                <div onClick={() => navigate(-2)} className='fixed top-6 left-3'>
                    <ArrowLeft className="text-black"/>
                </div>
                <h1 className="font-bold mb-2 sm:text-sm md:text-xl">All Added Vehicles</h1>
            </div>

            <div className="bg-white rounded-t-3xl -mt-4 flex-1 flex-col items-center">
                <div>
                    <div className="flex items-center gap-1">
                        <div className="py-4 pr-4 pl-2 flex-1 border-b">
                            <input
                                type="text"
                                placeholder="Search Vehicle"
                                value={searchTerm}
                                onChange={handleSearch}
                                style={{ border: '1px solid gray' }}
                                className="w-full p-3 rounded-xl border outline-none"
                            />
                        </div>
                        <button onClick={toggleFilter}>
                            <Filter className="w-6 h-6 text-gray-600 pr-2" />
                        </button>
                    </div>

                    {showFilter && (
                        <div style={{ boxShadow: '2px 2px 2px' }} className="absolute top-full right-4 transform -translate-y-10 bg-white shadow-xl border rounded-xl w-60 z-50">
                            <ul className="p-2 text-sm">
                                <li className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2">
                                    <CheckCircle className="w-4 h-4 text-green-500" />
                                    Working Vehicles
                                </li>
                                <li className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2">
                                    <XCircle className="w-4 h-4 text-red-500" />
                                    Non-Working Vehicles
                                </li>
                                <li className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2">
                                    <ArrowDownAZ className="w-4 h-4 text-gray-600" />
                                    Sort A to Z
                                </li>
                                <li className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2">
                                    <ArrowDownZA className="w-4 h-4 text-gray-600" />
                                    Sort Z to A
                                </li>
                            </ul>
                        </div>
                    )}
                </div>

                {/* List of Vehicles */}
                {filteredData.length === 0 ? (
                    <div className="flex items-center justify-center flex-1">
                        <p className="text-gray-500 text-lg">No data found.</p>
                    </div>
                ) : (
                    <div className="flex-1 overflow-y-auto px-4 py-2">
                        {filteredData.map((item, index) => (
                            <div
                                key={index}
                                style={{ borderBottom: '1px solid gray', borderTop: '1px solid gray', boxShadow: '2px 3px 0px', borderRadius: '20px', marginBottom: '1rem' }}
                                className="flex items-center justify-between pt-[1rem] pb-[1rem] border-b cursor-pointer relative"
                                onClick={() => navigate('/AddVehiclesVendorMaster', { state: { from: '/AllAddedVehicles', id: item.vendorDriverCode, isWorking: item.currentlyWorkingDriver } })}
                            >
                                <div style={{ borderBottom: '3px solid #21A6E9', boxShadow: '1px -2px 2px' }} className="rounded-full p-2 w-15 h-15 flex items-center justify-center ml-[1rem]">
                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/add/img3.png' alt="img" className="w-10 h-10 rounded-full" />
                                </div>
                                <div className="flex flex-col items-end ml-auto mr-2">
                                    <p className="text-[18px] font-bold">{item.vehicleNo}</p>
                                    <div className="flex items-center gap-2">
                                        {item.currentlyWorkingDriver && (<Circle className="text-green-500 fill-green-500 w-4 h-4 mt-[0.4rem]" />)}
                                        <p className="text-[12px] font-bold mt-1">{item.driverName}</p>
                                    </div>
                                </div>
                                <div className="relative" onClick={(e) => { e.stopPropagation(); }}>
                                    <MoreVertIcon
                                        className="text-gray-500 cursor-pointer"
                                        onClick={() => { setShowOptionsFor((prev) => prev === item.vendorDriverCode ? null : item.vendorDriverCode) }}
                                    />
                                    {showOptionsFor == item.vendorDriverCode && (
                                        <div key={index} className="absolute right-0 w-24 bg-white shadow-md border rounded z-10">
                                            <p
                                                className="text-sm px-4 py-2 hover:bg-red-100 text-gray-600 cursor-pointer"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    deleteItem(item.vendorDriverCode);
                                                    setShowOptionsFor(null);
                                                }}
                                            >
                                                Delete
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
                <div>
                    <button onClick={() => { navigate('/AddVehiclesVendorMaster', { state: { value: "additional-vehicles" } }) }} className="fixed bottom-3 right-3 px-4 py-3 rounded-xl text-white bg-[#2db6ff]">
                        Add New
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AllAddedVehicles;